<template>
  <ul class="operatelog-ul" v-loading="fullLoading">
    <li class="hm-search">
      <!-- 查询部分 -->
      <el-form :inline="true" :model="searchForm">
        <el-form-item :label="$t('Components.Log.OperateLog.Search')">
          <el-input
            v-model="searchForm.inputSearch"
            :placeholder="$t('Components.Log.OperateLog.PleaseInputSearch')"
            clearable
          />
        </el-form-item>

        <el-form-item :label="$t('Components.Log.OperateLog.Module')">
          <el-select
            v-model="searchForm.module"
            :placeholder="$t('Components.Log.OperateLog.PleaseChooseModule')"
            clearable
          >
            <el-option
              v-for="item in moduleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('Components.Log.OperateLog.Type')">
          <el-select
            v-model="searchForm.type"
            :placeholder="$t('Components.Log.OperateLog.PleaseSelectType')"
            clearable
          >
            <el-option
              v-for="item in accessLogTypesOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('Components.Log.OperateLog.Status')">
          <el-select
            v-model="searchForm.status"
            :placeholder="$t('Components.Log.OperateLog.PleaseSelectStatus')"
            clearable
          >
            <el-option
              :label="$t('Components.Log.OperateLog.Success')"
              :value="StatusCode.Success"
            />
            <!-- 非200就是错误，这边就给了500 -->
            <el-option
              :label="$t('Components.Log.OperateLog.Failure')"
              :value="StatusCode.ServerError"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="buttonVisible.searchButton"
            type="primary"
            @click="queryClick"
            :icon="Search"
            >{{ $t("Components.Log.OperateLog.Search1") }}</el-button
          >
          <el-button
            v-if="buttonVisible.resetButton"
            @click="resetClick"
            :icon="RefreshLeft"
            >{{ $t("Components.Log.OperateLog.Reset") }}</el-button
          >
        </el-form-item>
      </el-form>
    </li>
    <li class="hm-operate">
      <!-- 操作部分 -->
      <el-button
        v-if="buttonVisible.deleteButton"
        :disabled="!(selectAccessLogs && selectAccessLogs.length > 0)"
        :style="{ color: 'white' }"
        :icon="Delete"
        :color="ButtonColor.Delete"
        @click="handleDeleteBatch"
        >{{ $t("Components.Log.OperateLog.Delete") }}</el-button
      >
      <el-button
        v-if="buttonVisible.clearButton"
        :disabled="total <= 0"
        :style="{ color: 'white' }"
        :icon="Delete"
        :color="ButtonColor.Clear"
        @click="handleClear"
        >{{ $t("Components.Log.OperateLog.Clear") }}</el-button
      >
      <el-button
        v-if="buttonVisible.exportButton"
        :style="{ color: 'white' }"
        :icon="Download"
        :color="ButtonColor.Export"
        @click="handleExport"
        >{{ $t("Components.Log.OperateLog.Export") }}</el-button
      >
    </li>
    <el-scrollbar>
      <li class="operatelog-li-table">
        <!-- 表格部分 -->
        <el-table
          v-loading="tableLoading"
          :data="tableData"
          row-key="id"
          @sort-change="handleSortChange"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column
            prop="id"
            width="100"
            :label="$t('Components.Log.OperateLog.Id')"
          />
          <el-table-column
            prop="module"
            min-width="100"
            :label="$t('Components.Log.OperateLog.Module')"
          >
            <template #default="scope">
              <el-text
                v-if="scope.row.module === AccessLogModule.SysemModule"
                >{{ $t("Common.AccessLogModule.SystemModule") }}</el-text
              >
              <el-text v-else-if="scope.row.module === AccessLogModule.Util">{{
                $t("Common.AccessLogModule.UtilModule")
              }}</el-text>
              <el-text
                v-else-if="scope.row.module === AccessLogModule.BaseService"
                >{{ $t("Common.AccessLogModule.BaseServiceModule") }}</el-text
              >
              <el-text v-else-if="scope.row.module === AccessLogModule.Log">{{
                $t("Common.AccessLogModule.LogModule")
              }}</el-text>
              <el-text v-else-if="scope.row.module === AccessLogModule.Database">{{
                $t("Common.AccessLogModule.Database")
              }}</el-text>
              <el-text v-else-if="scope.row.module === AccessLogModule.Project">{{
                $t("Common.AccessLogModule.Project")
              }}</el-text>
              <el-text v-else-if="scope.row.module === AccessLogModule.ReviewApprove">{{
                $t("Common.AccessLogModule.ReviewApprove")
              }}</el-text>
              <el-text v-else-if="scope.row.module === AccessLogModule.Progress">{{
                $t("Common.AccessLogModule.Progress")
              }}</el-text>
              <el-text v-else-if="scope.row.module === AccessLogModule.WorkingHours">{{
                $t("Common.AccessLogModule.Progress")
              }}</el-text>
              <el-text v-else-if="scope.row.module === AccessLogModule.Calendar">{{
                $t("Common.AccessLogModule.Progress")
              }}</el-text>
              <el-text v-else-if="scope.row.module === AccessLogModule.Statistics">{{
                $t("Common.AccessLogModule.Progress")
              }}</el-text>
              <el-text class="mx-1" v-else type="danger">{{
                $t("Common.AccessLogModule.NoModule")
              }}</el-text>
            </template>
          </el-table-column>
          <el-table-column
            prop="type"
            min-width="80"
            :label="$t('Components.Log.OperateLog.Type')"
          >
            <template #default="scope">
              <el-tag
                v-if="scope.row.type === AccessLogType.Search"
                effect="dark"
              >
                {{ $t("Common.AccessLogType.Search") }}
              </el-tag>
              <el-tag
                v-else-if="scope.row.type === AccessLogType.Add"
                :style="{ color: 'white' }"
                :color="ButtonColor.Add"
              >
                {{ $t("Common.AccessLogType.Add") }}
              </el-tag>
              <el-tag
                v-else-if="scope.row.type === AccessLogType.Modify"
                :style="{ color: 'white' }"
                :color="ButtonColor.Edit"
              >
                {{ $t("Common.AccessLogType.Modify") }}
              </el-tag>
              <el-tag
                v-else-if="scope.row.type === AccessLogType.SingleDelete"
                :style="{ color: 'white' }"
                :color="ButtonColor.Delete"
              >
                {{ $t("Common.AccessLogType.SingleDelete") }}
              </el-tag>
              <el-tag
                v-else-if="scope.row.type === AccessLogType.BatchDelete"
                :style="{ color: 'white' }"
                :color="ButtonColor.Delete"
              >
                {{ $t("Common.AccessLogType.BatchDelete") }}
              </el-tag>
              <el-tag
                v-else-if="scope.row.type === AccessLogType.Export"
                :style="{ color: 'white' }"
                :color="ButtonColor.Export"
              >
                {{ $t("Common.AccessLogType.Export") }}
              </el-tag>
              <el-tag
                v-else-if="scope.row.type === AccessLogType.Import"
                :style="{ color: 'white' }"
                :color="ButtonColor.Import"
              >
                {{ $t("Common.AccessLogType.Import") }}
              </el-tag>
              <el-tag
                v-else-if="scope.row.type === AccessLogType.Clear"
                :style="{ color: 'white' }"
                :color="ButtonColor.Clear"
              >
                {{ $t("Common.AccessLogType.Clear") }}
              </el-tag>
              <el-tag
                v-else-if="scope.row.type === AccessLogType.Dataflag"
                :style="{ color: 'white' }"
                :color="ButtonColor.DataflagY"
              >
                {{ $t("Common.AccessLogType.Dataflag") }}
              </el-tag>
              <el-tag
                v-else-if="scope.row.type === AccessLogType.Login"
                :style="{ color: 'white' }"
                :color="ButtonColor.Login"
              >
                {{ $t("Common.AccessLogType.Login") }}
              </el-tag>
              <el-tag
                v-else
                :style="{ color: 'white' }"
                :color="ButtonColor.Other"
              >
                {{ $t("Common.AccessLogType.NoType") }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="method"
            min-width="80"
            :label="$t('Components.Log.OperateLog.Method')"
          />
          <el-table-column
            prop="ip"
            min-width="100"
            :label="$t('Components.Log.OperateLog.IP')"
          />
          <el-table-column
            prop="address"
            min-width="180"
            show-overflow-tooltip
            :label="$t('Components.Log.OperateLog.Address')"
          />
          <el-table-column
            prop="time_consuming"
            width="80"
            :label="$t('Components.Log.OperateLog.TimeConsuming')"
          >
          <template #default="scope">
            <span>{{ scope.row.time_consuming.toFixed(2) }}</span>
          </template>
          </el-table-column>

          <el-table-column
            prop="status"
            min-width="80"
            :label="$t('Components.Log.OperateLog.Status')"
          >
            <template #default="scope">
              <el-tag
                v-if="scope.row.status == StatusCode.Success"
                type="success"
              >
                {{ $t("Components.Log.OperateLog.Success") }}
              </el-tag>
              <el-tag v-else type="warning">
                {{ $t("Components.Log.OperateLog.Failure") }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="createname"
            min-width="80"
            :label="$t('Components.Log.OperateLog.OperateName')"
          />
          <el-table-column
            prop="createtime"
            sortable
            min-width="100"
            :label="$t('Components.Log.OperateLog.OperateTime')"
          />
          <el-table-column
            :label="$t('Components.Log.OperateLog.Operate')"
            width="200"
          >
            <template #default="scope">
              <el-space wrap>
                <el-button
                  v-if="buttonVisible.viewButtonLine"
                  @click="handleView(scope.row)"
                  type="primary"
                  :icon="View"
                  size="small"
                  bg
                  >{{ $t("Components.Log.OperateLog.View") }}</el-button
                >
                <el-button
                  v-if="buttonVisible.deleteButtonLine"
                  :style="{ color: 'white' }"
                  :icon="Delete"
                  :color="ButtonColor.Delete"
                  size="small"
                  bg
                  @click="handleDelete(scope.row)"
                  >{{ $t("Components.Log.OperateLog.Delete") }}</el-button
                >
              </el-space>
            </template>
          </el-table-column>
        </el-table>
      </li>
    </el-scrollbar>

    <li class="hm-page">
      <el-pagination
      small
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :page-sizes="AllPageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </li>
  </ul>
  <ViewOperateLog
    v-if="dialogVisible"
    :editData="editData"
    @handleCloseDialog="handleCloseDialog"
  />
</template>
<script setup>
import {
  reactive,
  ref,
  markRaw,
  onMounted,
  watchEffect,
} from "vue";
import {
  Delete,
  RefreshLeft,
  Search,
  WarnTriangleFilled,
  Download,
  View,
} from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { useI18n } from "vue-i18n";
import {
  AllPageSize,
  ButtonColor,
  DefaultPageSize,
} from "@/consts/frame";
import {
  request_accesslog_page,
  request_accesslog_delete,
  request_accesslog_delete_batch,
  request_accesslog_export,
  request_accesslog_clear,
} from "@/api/apis";
import ViewOperateLog from "@/components/Log/OperateLog/ViewOperateLog.vue";
import { useStore } from "@/store/index";
import { AccessLogType, AccessLogModule } from "@/consts/enum";
import StatusCode from "@/api/statusCode";
import { MenuCodes, MenuButtonCodes } from "@/consts/menuAndMenuButtonCode";
import { validateMenuButton } from "@/util/util";

const store = useStore();
const { t } = useI18n();
const searchForm = reactive({
  inputSearch: "",
  type: undefined,
  module: undefined,
  status: undefined,
});
const buttonVisible = reactive({
  searchButton: false,
  resetButton: false,
  deleteButton: false,
  clearButton: false,
  viewButtonLine: false,
  deleteButtonLine: false,
  exportButton: false,
});
// 当前页码
const currentPage = ref(1);
// 页码大小
const pageSize = ref(DefaultPageSize);
// 表格数据
const tableData = ref([]);
// 表格加载
const tableLoading = ref(false);
// 总数量
const total = ref(0);
// 编辑的数据
const editData = ref({});
// 弹窗是否可见
const dialogVisible = ref(false);
// 创建时间排序规则 如果为undefined 则没有这个参数，如果为true代表倒叙，为false代表正序
const createTimeSort = ref(true);
// 选择的通知公告
const selectAccessLogs = ref([]);
// 全屏加载
const fullLoading = ref(false);

const accessLogTypesOptions = ref([]);
const moduleOptions = ref([]);

onMounted(async () => {
  accessLogTypesOptions.value.push({
    label: t("Common.AccessLogType.Search"),
    value: AccessLogType.Search,
  });
  accessLogTypesOptions.value.push({
    label: t("Common.AccessLogType.Add"),
    value: AccessLogType.Add,
  });
  accessLogTypesOptions.value.push({
    label: t("Common.AccessLogType.Modify"),
    value: AccessLogType.Modify,
  });
  accessLogTypesOptions.value.push({
    label: t("Common.AccessLogType.SingleDelete"),
    value: AccessLogType.SingleDelete,
  });
  accessLogTypesOptions.value.push({
    label: t("Common.AccessLogType.BatchDelete"),
    value: AccessLogType.BatchDelete,
  });
  accessLogTypesOptions.value.push({
    label: t("Common.AccessLogType.Export"),
    value: AccessLogType.Export,
  });
  accessLogTypesOptions.value.push({
    label: t("Common.AccessLogType.Import"),
    value: AccessLogType.Import,
  });
  accessLogTypesOptions.value.push({
    label: t("Common.AccessLogType.Clear"),
    value: AccessLogType.Clear,
  });
  accessLogTypesOptions.value.push({
    label: t("Common.AccessLogType.Dataflag"),
    value: AccessLogType.Dataflag,
  });
  accessLogTypesOptions.value.push({
    label: t("Common.AccessLogType.Login"),
    value: AccessLogType.Login,
  });

  moduleOptions.value.push({
    label: t("Common.AccessLogModule.SystemModule"),
    value: AccessLogModule.SysemModule,
  });
  moduleOptions.value.push({
    label: t("Common.AccessLogModule.BaseServiceModule"),
    value: AccessLogModule.BaseService,
  });
  moduleOptions.value.push({
    label: t("Common.AccessLogModule.UtilModule"),
    value: AccessLogModule.Util,
  });
  moduleOptions.value.push({
    label: t("Common.AccessLogModule.LogModule"),
    value: AccessLogModule.Log,
  });
  moduleOptions.value.push({
    label: t("Common.AccessLogModule.Database"),
    value: AccessLogModule.Database,
  });
  moduleOptions.value.push({
    label: t("Common.AccessLogModule.Project"),
    value: AccessLogModule.Project,
  });
  moduleOptions.value.push({
    label: t("Common.AccessLogModule.ReviewApprove"),
    value: AccessLogModule.ReviewApprove,
  });
  moduleOptions.value.push({
    label: t("Common.AccessLogModule.Progress"),
    value: AccessLogModule.Progress,
  });

  await getAccesslogPage();
});
// 分页查询通知公告
const getAccesslogPage = async () => {
  const trans = {
    pagesize: pageSize.value,
    pageindex: currentPage.value,
    text: searchForm.inputSearch,
    createTimeSort: createTimeSort.value,
    type: searchForm.type,
    module: searchForm.module,
    status: searchForm.status,
  };
  tableLoading.value = true;
  const result = await request_accesslog_page(
    trans,
    () => (tableLoading.value = false)
  );
  total.value = result.total;
  tableData.value = result.rows;
  selectAccessLogs.value = [];
  editData.value = {};
};

// 查询事件
const queryClick = () => {
  getAccesslogPage();
};
// 重置事件
const resetClick = () => {
  searchForm.dataflag = undefined;
  searchForm.inputSearch = "";
  searchForm.module = undefined;
  searchForm.type = undefined;
  searchForm.status = undefined;
  getAccesslogPage();
};
// 处理页码大小改变事件
const handleSizeChange = (size) => {
  pageSize.value = size;
  getAccesslogPage();
};
// 处理当前页改变事件
const handleCurrentChange = (index) => {
  currentPage.value = index;
  getAccesslogPage();
};
// 处理查看事件
const handleView = (row) => {
  editData.value = {
    guid: row.guid,
    module: row.module,
    type: row.type,
    method: row.method,
    ip: row.ip,
    address: row.address,
    status: row.status,
    message: row.message,
    request: row.request,
    response: row.response,
    createtime: row.createtime,
    createname: row.createname,
  };
  dialogVisible.value = true;
};
// 处理回调关闭事件
const handleCloseDialog = () => {
  dialogVisible.value = false;
  editData.value = {};
};
// 处理选择回调事件
const handleSelectionChange = (ammouncements) => {
  selectAccessLogs.value = ammouncements;
};
// 处理删除
const handleDelete = async (row) => {
  ElMessageBox.confirm(
    t("Components.Log.OperateLog.ConfirmDeleteAccessLog"),
    t("Common.ElMessageBox.OperateConfirm"),
    {
      confirmButtonText: t("Common.ElMessageBox.ConfirmText"),
      cancelButtonText: t("Common.ElMessageBox.CancelText"),
      type: "warning",
      icon: markRaw(WarnTriangleFilled),
    }
  )
    .then(async () => {
      await request_accesslog_delete(row.guid, true);
      getAccesslogPage();
    })
    .catch(() => {});
};
// 批量删除
const handleDeleteBatch = async () => {
  if (selectAccessLogs.value.length === 0) {
    ElMessage.warning(t("Components.Log.OperateLog.AtLeastOneAccesslog"));
    return;
  }
  ElMessageBox.confirm(
    t("Components.Log.OperateLog.ConfirmDeleteAccessLog"),
    t("Common.ElMessageBox.OperateConfirm"),
    {
      confirmButtonText: t("Common.ElMessageBox.ConfirmText"),
      cancelButtonText: t("Common.ElMessageBox.CancelText"),
      type: "warning",
      icon: markRaw(WarnTriangleFilled),
    }
  )
    .then(async () => {
      const trans = {
        guids: selectAccessLogs.value.map((item) => item.guid),
      };
      await request_accesslog_delete_batch(trans, true);
      getAccesslogPage();
    })
    .catch(() => {});
};
// 处理排序改变事件
const handleSortChange = async ({ prop, order }) => {
  if (prop === "createtime") {
    // 创建时间排序
    if (order === "ascending") {
      // 时间正序
      createTimeSort.value = false;
    } else if (order === "descending") {
      // 时间倒叙
      createTimeSort.value = true;
    } else {
      createTimeSort.value = undefined;
    }
  }
  await getAccesslogPage();
};
// 导出
const handleExport = async () => {
  fullLoading.value = true;
  const trans = {
    pagesize: pageSize.value,
    pageindex: currentPage.value,
    text: searchForm.inputSearch,
    createTimeSort: createTimeSort.value,
    type: searchForm.type,
    module: searchForm.module,
    status: searchForm.status,
  };
  const result = await request_accesslog_export(
    trans,
    true,
    () => (fullLoading.value = false)
  );
  const link = document.createElement("a");
  link.style.display = "none";
  link.href = result;
  link.target = '_blank'
  document.body.appendChild(link);
  link.click();
};
// 处理清除
const handleClear = async () => {
  ElMessageBox.confirm(
    t("Components.Log.OperateLog.ConfirmClearAccessLog"),
    t("Common.ElMessageBox.OperateConfirm"),
    {
      confirmButtonText: t("Common.ElMessageBox.ConfirmText"),
      cancelButtonText: t("Common.ElMessageBox.CancelText"),
      type: "warning",
      icon: markRaw(WarnTriangleFilled),
    }
  )
    .then(async () => {
      fullLoading.value = true;
      await request_accesslog_clear(() => (fullLoading.value = false));
      getAccesslogPage();
    })
    .catch(() => {});
};
watchEffect(() => {
  if (store.userMenus) {
    // 处理查询
    buttonVisible.searchButton = validateMenuButton(
      store.userMenus,
      MenuCodes.Log.OperateLog,
      MenuButtonCodes.Log.OperateLog.OperateLogSearch
    );
    // 处理重置
    buttonVisible.resetButton = validateMenuButton(
      store.userMenus,
      MenuCodes.Log.OperateLog,
      MenuButtonCodes.Log.OperateLog.OperateLogReset
    );
    // 处理删除
    buttonVisible.addButton = validateMenuButton(
      store.userMenus,
      MenuCodes.Log.OperateLog,
      MenuButtonCodes.Log.OperateLog.OperateLogDelete
    );
    // 处理清空
    buttonVisible.editButton = validateMenuButton(
      store.userMenus,
      MenuCodes.Log.OperateLog,
      MenuButtonCodes.Log.OperateLog.OperateLogClear
    );
    // 处理删除
    buttonVisible.deleteButton = validateMenuButton(
      store.userMenus,
      MenuCodes.Log.OperateLog,
      MenuButtonCodes.Log.OperateLog.OperateLogDelete
    );
    // 处理查看
    buttonVisible.viewButtonLine = validateMenuButton(
      store.userMenus,
      MenuCodes.Log.OperateLog,
      MenuButtonCodes.Log.OperateLog.OperateLogDelete
    );
    // 处理删除行
    buttonVisible.deleteButtonLine = validateMenuButton(
      store.userMenus,
      MenuCodes.Log.OperateLog,
      MenuButtonCodes.Log.OperateLog.OperateLogDeleteLine
    );
    // 处理导出
    buttonVisible.exportButton = validateMenuButton(
      store.userMenus,
      MenuCodes.Log.OperateLog,
      MenuButtonCodes.Log.OperateLog.OperateLogExport
    );
  }
});
</script>
<style>
.operatelog-ul .el-scrollbar__view {
  height: calc(100% - 8px);
}
</style>
<style scoped lang="scss">
.operatelog-ul {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  height: 100%;
  .operatelog-li-search {
    // height: 100px;
  }
  .operatelog-li-table {
    // height: 100%;
    flex: 1;
    height: 100%;
    .el-table {
      height: 100%;
    }
  }
}
</style>
